import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ReleaseNotesService } from '../../services/master';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';

@Component({
  standalone: false,
  selector: 'app-whats-new-list',
  templateUrl: './whats-new-list.component.html',
  styleUrls: ['./whats-new-list.component.scss']
})
export class WhatsNewListComponent implements OnInit, OnDestroy {
  public activeReleaseNotes = [];
  public inactiveReleaseNotes = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private releseNoteService: ReleaseNotesService,
    private datepipe: DatePipe,
    private router: Router,
    private permission: HasPermissionService,
  ) {}

  ngOnInit(): void {
    this.getAllReleaseNotes();
  }

  getAllReleaseNotes() {
    this.activeReleaseNotes = [];
    this.inactiveReleaseNotes = [];

    this.releseNoteService.apiReleaseNotesGetAllReleaseNotesGet().subscribe((data) => {
      const today = new Date();

      data.forEach((item) => {
        const parsedNotes = this.parseReleaseNotes(item.releaseNote);
        const parsedInitialDate = this.parseDate(item.initialDate);
        const endDate = new Date(item.endDate);

        const note = {
          ...item,
          releaseNote: parsedNotes.ReleaseNotes,
          initialDate: parsedInitialDate
        };

        if (item.isActive && today <= endDate) {
          this.activeReleaseNotes.push(note);
        } else {
          this.inactiveReleaseNotes.push(note);
        }
      });
    });
  }

  parseDate(date: string): string {
    try {
      return this.datepipe.transform(new Date(date), 'd MMM y') || '';
    } catch {
      return '';
    }
  }

  parseReleaseNotes(jsonString: string): { ReleaseNotes: string[] } {
    try {
      return JSON.parse(jsonString);
    } catch {
      return { ReleaseNotes: [] };
    }
  }

  openAddReleaseNote() {
    this.router.navigate(['/whats-new-add']);
  }

  goBackToWhatsNew(): void {
    this.router.navigate(['/whats-new']); 
  }
  editNote(releaseNote: any): void {
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(releaseNote))));
    this.router.navigate(['/whats-new-edit'], {
      queryParams: { data: encoded }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}